
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_12jtc_9",
  "breadcrumb": "awsui_breadcrumb_1kosq_12jtc_13",
  "ghost-breadcrumb": "awsui_ghost-breadcrumb_1kosq_12jtc_14",
  "icon": "awsui_icon_1kosq_12jtc_17",
  "anchor": "awsui_anchor_1kosq_12jtc_23",
  "text": "awsui_text_1kosq_12jtc_71",
  "last": "awsui_last_1kosq_12jtc_90"
};
  